import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

export const retrieve = ({ commit }, id) => {
  commit(types.ORDER_SHOW_TOGGLE_LOADING)

  return fetch(id)
    .then(response => response.json())
    .then((data) => {
      commit(types.ORDER_SHOW_TOGGLE_LOADING)
      commit(types.ORDER_SHOW_SET_RETRIEVED, data)
    })
    .catch((e) => {
      commit(types.ORDER_SHOW_TOGGLE_LOADING)
      commit(types.ORDER_SHOW_SET_ERROR, e.message)
    })
}

export const paymentMethod = ({ commit }, id) => {
  commit(types.ORDER_SHOW_TOGGLE_LOADING)

  return fetch(id)
    .then(response => response.json())
    .then((data) => {
      commit(types.ORDER_SHOW_TOGGLE_LOADING)
      commit(types.ORDER_SHOW_SET_PAYMENTMETHOD, data)
    })
    .catch((e) => {
      commit(types.ORDER_SHOW_TOGGLE_LOADING)
      commit(types.ORDER_SHOW_SET_ERROR, e.message)
    })
}


export const personOrder = ({ commit }, id) => {
  commit(types.ORDER_SHOW_TOGGLE_LOADING)

  return fetch(id)
    .then(response => response.json())
    .then((data) => {
      let lastEl;
      if(data['hydra:totalItems']>1){
        lastEl = data['hydra:member'][data['hydra:member'].length - 1];
      }
      else {
        lastEl = data['hydra:member'][0]
      }
      commit(types.ORDER_SHOW_TOGGLE_LOADING)
      commit(types.ORDER_SHOW_SET_PERSONORDER,lastEl)
    })
    .catch((e) => {
      commit(types.ORDER_SHOW_TOGGLE_LOADING)
      commit(types.ORDER_SHOW_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.ORDER_SHOW_RESET)
}
